module.exports = __webpack_public_path__ + "img/badge-product-page-right-corner.82e89eb8.svg";